const featureToggle = {
  rating: true,
  invoice: false,
};

exports.featureToggle = featureToggle;
